/**
 * The type-specific half of a `detect_cluster` agent's settings page: whether
 * it proposes variant groups as well as duplicates. Stored in
 * agent_settings.behavior_config.
 *
 * Twins and every custom agent made on its behavior show this same panel; the
 * rest of the page is the template's common switches.
 */

import { Switch } from '../../ds';
import { resolveClusterConfig } from '../../../lib/clusterRunner';
import type { BehaviorSettingsPanelProps } from './types';

export function ClusterSettings({ settings, isSaving, saveBehaviorConfig }: BehaviorSettingsPanelProps) {
  const behavior = resolveClusterConfig(settings);

  return (
    <div className="card space-y-4">
      <div>
        <h3 className="text-sm font-semibold text-[var(--text-pri)]">What it looks for</h3>
        <p className="text-xs text-[var(--text-ter)] mt-0.5">The settings that belong to this type of agent.</p>
      </div>
      <div>
        <div className="flex items-center justify-between gap-3">
          <p className="text-xs font-medium text-[var(--text-sec)]">Variants as well as duplicates</p>
          <Switch
            checked={behavior.includeVariants}
            disabled={isSaving}
            aria-label="Variants as well as duplicates"
            onChange={() => void saveBehaviorConfig({ ...behavior, includeVariants: !behavior.includeVariants })}
          />
        </div>
        <p className="text-xs text-[var(--text-ter)] mt-1">
          Duplicates say the same thing and would be resolved by the same work. Variants are close variations on one theme.
          Off: it proposes duplicates only.
        </p>
      </div>
    </div>
  );
}
